// extracted by css-extract-rspack-plugin
export default {"isSelected":"kbsHx"};